import React,{useState} from 'react'
import d15 from './ConfirmModal.module.css'
function ConfirmModal(props) {
  const [confirmModalOverlay, setConfirmModalOverlay] = useState(false)
    return (
        <div>
          {confirmModalOverlay && 
          
          <div className={d15.ModalOverlay}>
          <div className={d15.modal}>
            <div className={d15.messageContainer}>
           <div className={d15.message}> {props.message}</div>
           </div>
          <div className={d15.buttonContainer}>
            <button className={d15.yes} onClick={()=>{props.yes();setConfirmModalOverlay(false);}}>Yes</button>
            <button  className={d15.no} onClick={()=>setConfirmModalOverlay(false)}>No</button>
          </div>

          </div>  
          </div>}



          <div onClick={()=>{setConfirmModalOverlay(true)}}>
          { props.children }
          </div>
        </div>
    )
}

export default ConfirmModal
